var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 230,
    viewBox: "0 0 900 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 230,
    fill: "#F5F2FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/layer1.a43129e1906b9580ce1938eb2e6b2098.svg";
export { ForwardRef as ReactComponent };